import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import { GRAY_1100 } from 'constants/styling/upbrandingTheme'
import { MUIButton } from 'components/common/MUIButton'
import React from 'react'
import Stack from '@mui/material/Stack'
import { useTranslation } from 'react-i18next'

interface Props {
  /** Whether the button is disabled. */
  isDisabled?: boolean
  /** Whether the button and block are loading. */
  isLoading?: boolean
  /** Whether the button is regenerating. */
  isRegenerate?: boolean
  /** On click action to be triggerd. */
  onClick?: () => void
  /** Callback function to reset the state. */
  onResetState?: () => void
  /** Custom component to be displayed next to General button */
  customComponent?: React.ReactNode
}

/**
 * @component
 *
 * @example
 * <GenerateButton
 *   isDisabled={false}
 *   isLoading={false}
 *   isRegenerate={false}
 *   onClick={() => console.log('Button clicked')}
 *   onResetState={() => console.log('State reset')}
 *   customComponent={<CustomComponent />}
 * />
 */
export const GenerateButton: React.FC<Props> = ({
  isDisabled = false,
  isLoading = false,
  isRegenerate = false,
  onClick,
  onResetState,
  customComponent = null
}) => {

  const { t } = useTranslation(['ai_studio_editing'])

  return (
    <Stack
      position="absolute"
      bottom="2.4rem"
      alignItems="center"
      justifyContent="center"
    >

      <Stack
        direction="row"
        spacing="5.6rem"
        alignItems="center"
        sx={{
          backgroundColor: GRAY_1100,
          padding: '0.8rem',
          borderRadius: '4rem',
        }}
      >

        {customComponent}

        <MUIButton
          type="darkPrimary"
          disabled={isDisabled}
          isLoading={isLoading}
          onClick={onClick}
        >
          <AutoAwesomeOutlinedIcon fontSize="large" />
          {isRegenerate ? t('regenerate_button') : t('generate_button')}
        </MUIButton>

      </Stack>
    </Stack>
  )
}
